1<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "QuantifyTimeZoneConfig",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'quantifyTimeZoneConfig:add',
        update: 'quantifyTimeZoneConfig:update',
        delete: 'quantifyTimeZoneConfig:delete',
        deleteBatch: 'quantifyTimeZoneConfig:deleteBatch'
      },
      url: {
        get: '/quantifyTimeZoneConfig/listByCondition',
        add: '/quantifyTimeZoneConfig/add',
        update: '/quantifyTimeZoneConfig/update',
        delete: '/quantifyTimeZoneConfig/delete/',
        delete_batch: '/quantifyTimeZoneConfig/deleteBatch',
        status: '/quantifyTimeZoneConfig/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },{
        field: 'timeZoneName',
        label: '量化时区',
        show: true,
        width: '',
      },{
        field: 'hour',
        label: '小时',
        show: true,
        width: '',
      }, {
        field: 'minute',
        label: '分钟',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '配置量化时区',
        updateTitle: '配置量化时区',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'timeZoneName',
          label: '时区名称',
          type: 'input',
          placeholder: '时区名称',
          rules: [{message: '请输入时区名称', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'hour',
          label: '小时',
          type: 'input',
          placeholder: '小时',
          rules: [{message: '请输入小时', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },  {
          field: 'minute',
          label: '分钟',
          type: 'input',
          placeholder: '分钟',
          rules: [{message: '请输入分钟', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
